var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8c5.523 0 10 3.224 10 7.2s-4.477 7.2-10 7.2c-1.363 0-2.662-0.198-3.846-0.554l-4.154 2.154 0.683-3.904c-1.66-1.285-2.683-3.003-2.683-4.896 0-3.976 4.477-7.2 10-7.2zM16 6c-6.729 0-12 4.041-12 9.2 0 2.081 0.886 4.054 2.519 5.659l-1.186 6.776 7.052-3.656c1.167 0.279 2.379 0.421 3.615 0.421 6.729 0 12-4.041 12-9.2s-5.271-9.2-12-9.2v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityChat);
export default __webpack_public_path__ + "static/media/unity_chat.8c8d353dba084252b22bdc8952266989.svg";
export { ForwardRef as ReactComponent };